export class RegisterModel{
    organizzazioneId?: number;
    title: string;
    firstName: string;
    lastName: string;
    userName: string;
    email: string;
    password: string;
    confirmPassword: string;
    acceptTerms: boolean;
}
